export default theme => ({
  text: {
    fontSize: '0.65rem',
    lineHeight: 2.2
  }
});
